package repdb

import com.ustadmobile.door.room.RoomDatabase

public actual abstract class RepDb : RoomDatabase() {
  public actual abstract val repDao: RepDao

  public actual abstract val compositePkDao: CompositePkDao

  public actual abstract val repWithAttachmentDao: RepWithAttachmentDao
}
